// Components==============
import React from 'react';
import GlobalSideNav from './GloabalSideNav';
import GlobalAlert from './GlobalAlert';
import GlobalBuildingBlocksMounted from './GlobalBuildingBlocksMounted';
import GlobalConfirm from './GlobalConfirm';
import GlobalEvidence from './GlobalEvidence';
import GlobalFilterMenu from './GlobalFilterMenu';
import GlobalHeroContent from './GlobalHeroContent';
import GlobalOpenNavItems from './GlobalOpenNavItems';
import GlobalRecentActivities from './GlobalRecentActivities';
import GlobalReflection from './GlobalReflectionContext';
import GlobalRootDream from './GlobalRootDream';
import GlobalRootModal from './GlobalRootModal';
import GlobalRootPerson from './GlobalRootPerson';
import GlobalRootSkill from './GlobalRootSkill';
import GlobalTrainingUser from './GlobalTrainingUser';
import GlobalTranslate from './GlobalTranslate';
import GlobalUploadImageModal from './GlobalUploadImageModal';
import GlobalScan from './GlobalScan';
// =========================

export default function GlobalContextWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <GlobalTranslate>
      <GlobalSideNav>
        <GlobalFilterMenu>
          <GlobalOpenNavItems>
            <GlobalHeroContent>
              <GlobalBuildingBlocksMounted>
                <GlobalAlert>
                  <GlobalConfirm>
                    <GlobalRootModal>
                      <GlobalReflection>
                        <GlobalTrainingUser>
                          <GlobalUploadImageModal>
                            <GlobalEvidence>
                              <GlobalRecentActivities>
                                <GlobalRootDream>
                                  <GlobalRootSkill>
                                    <GlobalRootPerson>
                                      <GlobalScan>
                                      {children}
                                      </GlobalScan>
                                    </GlobalRootPerson>
                                  </GlobalRootSkill>
                                </GlobalRootDream>
                              </GlobalRecentActivities>
                            </GlobalEvidence>
                          </GlobalUploadImageModal>
                        </GlobalTrainingUser>
                      </GlobalReflection>
                    </GlobalRootModal>
                  </GlobalConfirm>
                </GlobalAlert>
              </GlobalBuildingBlocksMounted>
            </GlobalHeroContent>
          </GlobalOpenNavItems>
        </GlobalFilterMenu>
      </GlobalSideNav>
    </GlobalTranslate>
  );
}
